<template>
  <div class="container-fluid padding-right-0px">
    <div class="add-remove-element-action-list">
      <div class="row padding-top-13px padding-left-3px">
        <div class="col-md-12 col-lg-12 padding-right-0px padding-left-35px">
          <ul class="col-md-12 col-lg-12 text-align-left padding-left-0px padding-right-0px">
            <li class="padding-3px">
              <div class="row vertical-align">
                <div class="filled-circle col-md-1 col-lg-1 cursor-pointer text-color-white background-color-orange">
                  <input type="checkbox" v-model="getPersonalizationElementListToPost" :value="currComponentElementObj.ElementId">
                  </div>  
                <div class="col-md-9 col-lg-9">
                  <div class="row">
                    <span class="col-md-12 col-lg-12 orange-text-color">
                      {{currElementType}}
                    </span>
                  </div>
                  <div class="row orange-text-color">
                    <div class="col-md-12 col-lg-12">
                      {{currComponentElementObj.Title}}
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedMissionCheckIn"></confirmation-alert>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
// import find from 'lodash/find'
// import intersectionWith from 'lodash/intersectionWith'
export default {
  props: ['parentElementObj', 'lessonObj', 'currRenderedModuleObj', 'currComponentElementObj', 'completedLessonStepList'],
  created: function () {
    this.getCurrentElementTypeName()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showConfirmationBox: false,
      prefixString: '',
      postString: '?',
      currElementType: ''
    }
  },
  name: 'add-remove-element-action-list',
  methods: {
    getCurrentElementTypeName: function () {
      switch (this.currComponentElementObj.Type) {
        case 0:
          this.currElementType = 'Video'
          break
        case 1:
          this.currElementType = 'Challenge'
          break
        case 2:
          this.currElementType = 'Reflection'
          break
        case 3:
          this.currElementType = 'MCQ'
          break
        case 4:
          this.currElementType = 'Tookit'
          break
        case 5:
          this.currElementType = 'Diary'
          break
        case 6:
          this.currElementType = 'Note'
          break
        case 7:
          this.currElementType = 'Bonus'
          break
        case 8:
          this.currElementType = 'Document'
          break
        case 9:
          if (parseInt(this.currComponentElementObj.RDType) === parseInt(constants.DescVideoType.Teachback)) {
            this.currElementType = 'Teachback'
          } else {
            this.currElementType = 'Descriptive Video'
          }
          break
        case 10:
          this.currElementType = 'Rating'
          break
        case 11:
          this.currElementType = 'Learning Game'
          break
        case 12:
          this.currElementType = 'Mission'
          break
        case 14:
          this.currElementType = 'Assessment'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay
  },
  computed: {
    getParentLessonObj: {
      get: function () {
        return this.lessonObj
      }
    },
    getCurrentlyRenderedLessonObj: {
      get: function () {
        return this.currRenderedModuleObj
      }
    },
    getPersonalizationElementListToPost: {
      get: function () {
        return this.$store.state.personalizationElementListToPost
      },
      set: function (newValue) {
        this.$store.state.personalizationElementListToPost = newValue
        console.log('this.$store.state.personalizationElementListToPost: ' + this.$store.state.personalizationElementListToPost.length)
      }
    }
  }
}
</script> 
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer !important;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.margin-left-10px {
    margin-left: 10px;
}
.padding-3px {
    padding:3px;
}
.padding-bottom-3px {
  padding-bottom:3px;
}
.padding-left-8px {
  padding-left:8px;
}
ul {
  list-style-type: none;
}
.filled-circle {
  height: 25px;
  width: 25px;
  background-color: grey;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  padding: 2px;
}
.filled-circle-mission-checkin {
  height: 25px;
  width: 25px;
  background-color: blanchedalmond;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  padding: 2px;
}
.cursor-default {
  cursor:default;
}
.margin-bottom-10px {
  margin-bottom:10px;
}
.background-color-green {
    background-color: #0D9335;
}
.text-color-white {
  color:white;
}
.padding-left-58px {
  padding-left:58px;
}
.padding-top-13px {
  padding-top:13px;
}
.padding-left-3px {
  padding-left:3px;
}
.padding-left-35px {
  padding-left:35px;
}
.width-15px {
  width:15px;
}
.height-15px {
  height:15px;
}
.font-weight-bold {
  font-weight: 600;
}
.padding-0px {
  padding: 0px;
}
.padding-left-2px {
  padding-left:2px;
}
.padding-0px {
  padding: 0px;
}
.padding-left-4px {
  padding-left:4px;
}
.color {
  color: #34495e;
}
.background-color-orange {
  background-color: #f39c12;
}
.orange-text-color {
  color: #f39c12;
}
.padding-left-25px {
  padding-left:25px;
}
.padding-left-15px {
  padding-left:15px;
}
.padding-left-24px {
  padding-left:24px;
}
.color-green {
  color:#447417;
}
.padding-6px-23px {
  padding: 6px 23px;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa !important;
}
</style>



// WEBPACK FOOTER //
// src/components/personalization_rule/RemoveStepActionList.vue